import { useEffect, useState } from "react";
import "../../features/modal.css";
import { Users } from "../../interfaces/UserInterface";
import { dataEncrypt } from "../../features/data-encrypt";
import { API_LOGIN } from "../../features/constants";
import { Alerta, Toast } from "../../features/toast";
import { UserUpdate } from "./userUpdate";

interface LoginProps {
    setUser: React.Dispatch<React.SetStateAction<Users>>
}

export const Login = ({setUser}:LoginProps)=>{

    const [verFormLog, setVerFormLog] = useState(false);
    const [userEncrypted, setUserEncrypted] = useState("");
    const [pwdEncrypted, setPwdEncrypted] = useState("");
    const [loggedIn, setLoggedIn] = useState(false);
    const [userLog, setUserLog] = useState<Users>();

    useEffect(()=>{
        document.getElementById("userText")?.focus();
    },[verFormLog])

    const enviar = (e:string)=>{
        if(e === '13'){
            logear();
        }
    }

    const passFocus = (e:string)=>{
        if(e === '13')
            document.getElementById("pwdText")?.focus();
    }

    const logear = ()=>{
        //logica de logueo
        
        //logica de autenticasión
        //encryptar usuario y contraseña
       // setUserEncrypted(dataEncrypt(usr));
        //enviar usuario y contraseña encriptados a la API
        
        let init = {
            method: "POST",
            body: JSON.stringify({
                User: userEncrypted,
                Password: pwdEncrypted
            }),
            header:{
                "Content-Type":"aplication/json"
            }
        };

        fetch(API_LOGIN + "/login",init)
            .then(respons=>respons.json())
            .catch((error:string)=>{
                console.log(error);
                Alerta.fire({
                    title:"Error al intentar acceder a la base de datos",
                    text: error.toString(),
                    icon: "error"
                })
            })
            .then((data:Users[])=>{
            if (data){
                if(data[0] !== undefined){
                    Toast.fire({
                        title: "LogIn",
                        text: "Se ha iniciado sesión correctamente",
                        icon: "success"
                    })
                    setLoggedIn(true);
                    setUser(data[0]);
                    setUserLog(data[0]);
                }else{
                    Toast.fire({
                        title: "Error de Inicio de Sesión",
                        text: "Usuario o Contraseña Incorrectos",
                        icon: "warning"
                    })
                    setLoggedIn(false);
                }
            }
            })
        setVerFormLog(false);
    }

    const desLogear = ()=>{
        Toast.fire({
            title: "Cierre de Sesión",
            text: "Se cerro la sesión correctamente",
            icon: "success"
        })
        setLoggedIn(false);
        setUserEncrypted("");
        setPwdEncrypted("");
        setUser({Id: "", User: "", Password: "", Nombre: ""});
        setUserLog({Id: "", User: "", Password: "", Nombre: ""});
    }

    return(
        <div>

            {
                verFormLog?
                    <div className="modal">
                        <div className="modal-content modal-size-4">
                            <div className="modal-header d-flex justify-content-between align-items-center">
                                <h5 className="modal-title">Inicio de Sesión</h5>
                                <div className="logo">Si.T.A.</div>
                            </div>
                            
                            <div className="modal-body">
                                
                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Usuario</label>
                                    <input
                                        id="userText"
                                        type="text"
                                        className="form-control"
                                        onBlur={(e)=>setUserEncrypted(dataEncrypt(e.target.value))}
                                        onKeyDown={(e)=>passFocus(e.keyCode.toString())}
                                    />
                                </div>

                                <div className="mb-3">
                                    <label htmlFor="" className="form-label">Contraseña</label>
                                    <input
                                        id="pwdText"
                                        type="password"
                                        className="form-control"
                                        onKeyUp={(e)=>setPwdEncrypted(dataEncrypt(e.currentTarget.value))}
                                        onKeyDown={(e)=>enviar(e.keyCode.toString())}
                                    />
                                </div>
                                
                            </div>
                            <div className="modal-footer">
                                <button className="btn btn-outline-dark mx-2" onClick={()=>setVerFormLog(false)} >Cancelar</button>
                                <button type="submit" className="btn btn-outline-success mx-2" onClick={logear}>Login</button>
                                
                            </div>
                        </div>
                    </div>
                    :
                    <div className="d-flex justify-content-center align-items-center">
                        {userLog?.Nombre} 
                        {
                            loggedIn?
                            <>
                                {userLog?.Nombre===""?"":<UserUpdate id={userLog?.Id}/> }
                                <button className="btn btn-outline-danger btn-sm mx-2" onClick={desLogear}>Log Out</button>
                            </>
                            :
                            <>
                                <button className="btn btn-outline-primary btn-sm mx-2" onClick={()=>setVerFormLog(true)}>Log In</button>
                            </>
                        }
                    </div>
                    
                
            }
            

        </div>
    )
}